'use client';
import React from 'react';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { formatTickerToURLFriendly } from '@benzinga/utils';
import styles from './QuoteBox.module.scss';

export interface QuoteBoxQuote {
  change: number;
  changePercent: number | string;
  lastTradePrice: number | string;
  symbol: string | string;
}

export interface QuoteBoxProps {
  quote?: QuoteBoxQuote | null;
}

export const QuoteBox: React.FC<QuoteBoxProps> = ({ quote }) => {
  const ticker = quote?.symbol ? formatTickerToURLFriendly(quote.symbol) : null;
  const change = quote?.change ?? 0;
  const changeClass = change > 0 ? 'positive' : change < 0 ? 'negative' : '';

  return (
    <a
      className={`${styles.quoteBlock} quote-block ${changeClass}`}
      data-action={`Quote Ticker Click - ${quote?.symbol || 'Unknown'}`}
      href={ticker ? `/quote/${ticker}` : undefined}
    >
      <span className={`${styles.quoteName} quotebox-quote-name`}>
        {quote === null ? '' : quote?.symbol ? quote.symbol : '-'}
      </span>
      <div className={styles.quoteData}>
        <span className={`${styles.quotePrice} quotebox-quote-price`}>
          {quote === null ? '' : quote?.lastTradePrice ? formatPrice(quote.lastTradePrice) : '-'}
        </span>
        <span className={`${styles.quoteChange} quotebox-quote-change ${changeClass}`}>
          {quote?.change ? (
            quote.change > 0 ? (
              <CaretUpOutlined className="quote-icon" />
            ) : (
              <CaretDownOutlined className="quote-icon" />
            )
          ) : null}
          <span>{quote === null ? '' : quote?.changePercent ? `${formatChangeValue(quote.changePercent)}%` : '-'}</span>
        </span>
      </div>
    </a>
  );
};

const formatChangeValue = change => {
  return change > 0 ? change : change * -1;
};

const formatPrice = price => {
  const abs = Math.abs(price);
  if (abs < 0.001) {
    return Number(price).toFixed(5);
  } else if (abs < 0.01) {
    return Number(price).toFixed(4);
  } else if (abs < 0.1) {
    return Number(price).toFixed(3);
  } else {
    return Number(price).toFixed(2);
  }
};
